import React from "react";
import { createStyles, WithStyles, withStyles, Theme } from "@material-ui/core/styles";
import { FiniteStateMachineObject } from "figma-fsm/lib/transformations/transformCanvasToFiniteStateMachine";
import Machine from "./Machine";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";

export interface MachineContainerStyleProps extends WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    machinesContainer: {
      display: "flex",
      flexDirection: "column",
      marginTop: "24px",
      [theme.breakpoints.up("md")]: {
        flexDirection: "row"
      }
    },
    helpText: {
      marginTop: "24px"
    }
  });

interface MachineContainerProps {
  machineObjects: ReadonlyArray<FiniteStateMachineObject>;
}

const MachinesContainer = ({
  classes,
  machineObjects
}: MachineContainerStyleProps & MachineContainerProps) => (
  <>
    <Typography className={classes.helpText} variant="body1">
      Copy one of your machines and paste it in the visualizer here:{" "}
      <Link href="https://statecharts.github.io/xstate-viz/" target="_blank">
        XState visualizer
      </Link>
    </Typography>
    <div className={classes.machinesContainer}>
      {machineObjects.map((machine, i) => (
        <Machine key={i} machineObject={machine} />
      ))}
    </div>
  </>
);

export default withStyles(styles)(MachinesContainer);
